import Vue from 'vue'
import Vuex, { Plugin, Store } from 'vuex'
import VuexPersistence from 'vuex-persist'
import createLogger from 'vuex/dist/logger'
import modules from '@/system/store/modules'
import { IAuthStore } from '@/features/auth/store'
import { IJobStore } from '@/features/job/store'
import { IMatchFieldsStore } from '@/features/matchFields/store'
import { IProjectStore } from '@/features/projectList/store'
import { IUploadStore } from '@/features/upload/store'
import { ISocketState } from '@/system/socket/store'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (store: IStore) => {
    if (!store.auth.token) return {}
    return store
  }
})

const { NODE_ENV } = process.env
const debug = NODE_ENV !== 'production'
const plugins: Plugin<any>[] = [vuexLocal.plugin]

if (debug) {
  plugins.push(createLogger({
    collapsed: true
  }))
}

const store = new Store({
  state: {},
  modules,
  strict: debug,
  plugins
})

export interface IActionType<ParamType = any> {
  (param?: ParamType): Promise<any>
}

export interface IStore {
  auth: IAuthStore,
  job: IJobStore,
  projectList: IProjectStore,
  matchFields: IMatchFieldsStore,
  upload: IUploadStore,
  socket: ISocketState
}

export default store
